import { cn } from "@/lib/utils";
import malaysianFlag from "@/assets/icons/malaysia.svg";
import globalFlag from "@/assets/icons/global.svg";
import localFlag from "@/assets/icons/local.svg";
import { formatCurrency } from "@/utils/formatCurrency";
import { Separator } from "@/components/ui/separator";
import type { PriceBreakdown } from "@/types/purchase-ticket/invoice";

type PriceBreakdownProps = {
  priceBreakdown: PriceBreakdown[];
  grandTotal: number;
  className?: string;
};

export function PriceBreakdown({
  priceBreakdown = [],
  grandTotal = 0,
  className,
}: PriceBreakdownProps) {
  
  return (
    <div
      className={cn("overflow-hidden rounded-2xl bg-card shadow-xl", className)}
    >
      <div className="grid grid-cols-[1fr_1fr_auto] h-10 items-center gap-2 bg-primary px-4 py-2 text-xs font-medium text-primary-foreground">
        <span>Passenger Type</span>
        <span className="text-center">Qty</span>
        <span className="w-24 text-right">Price</span>
      </div>

      <div className="flex flex-col gap-4 px-4 pt-2 pb-4">
        {priceBreakdown.map((line, index) => (
          <div
            key={`${line.ticketTypeName}-${index}`}
            className="grid grid-cols-[1fr_1fr_auto] items-center gap-2 text-xs font-medium text-secondary-foreground"
          >
            <span className="flex items-center gap-3">
             {line.ticketTypeCategory === "Malaysian" ? (
                <img src={malaysianFlag} alt="Malaysian Flag" />
              ) : line.ticketTypeCategory === "Local" ? (
                <img src={localFlag} className="size-5" alt="Local Flag" />
              ) : (
                <img src={globalFlag} alt="Global Flag" />
              )}
              {line.ticketTypeName}
            </span>
            <span className="text-center">{line.quantity}</span>
            <span className="w-24 text-right">
              {formatCurrency(line.lineTotal)}
            </span>
          </div>
        ))}

        <Separator orientation="horizontal" />
        <div className="flex items-center justify-between text-sm font-medium text-secondary-foreground">
          <span>Grand Total</span>
          <span>{formatCurrency(grandTotal)}</span>
        </div>
      </div>
    </div>
  );
}
